import { render, staticRenderFns } from "./mlsSendSettings.vue?vue&type=template&id=3c5ba966&"
import script from "./mlsSendSettings.vue?vue&type=script&lang=js&"
export * from "./mlsSendSettings.vue?vue&type=script&lang=js&"
import style0 from "./mlsSendSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5ba966')) {
      api.createRecord('3c5ba966', component.options)
    } else {
      api.reload('3c5ba966', component.options)
    }
    module.hot.accept("./mlsSendSettings.vue?vue&type=template&id=3c5ba966&", function () {
      api.rerender('3c5ba966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/mlsSendSettings.vue"
export default component.exports